export default [
    {
        path: '/layouts',
        name:'mail-layout',
        component:()=> import('@/views/pages/cloudx/layout/Layout')
    }
]
  